module.exports = __webpack_public_path__ + "img/splash-platform-signature.5ce6b34.png";